/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type EvalHistoricalImportObjectSource = {
  type: "huggingface";
  repo: string;
  revision: string;
};

export type EvalHistoricalImportObject = {
  object: "eval.import";
  source: EvalHistoricalImportObjectSource;
  suiteId: string;
  suiteVersion: number;
  createdSuite: boolean;
  createdSuiteVersion: boolean;
  dryRun: boolean;
  discoveredFiles: number;
  importedRuns: number;
  skippedRuns: number;
  importedSamples: number;
};

/** @internal */
export const EvalHistoricalImportObjectSource$inboundSchema: z.ZodType<
  EvalHistoricalImportObjectSource,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("huggingface"),
  repo: z.string(),
  revision: z.string(),
});
/** @internal */
export type EvalHistoricalImportObjectSource$Outbound = {
  type: "huggingface";
  repo: string;
  revision: string;
};

/** @internal */
export const EvalHistoricalImportObjectSource$outboundSchema: z.ZodType<
  EvalHistoricalImportObjectSource$Outbound,
  z.ZodTypeDef,
  EvalHistoricalImportObjectSource
> = z.object({
  type: z.literal("huggingface"),
  repo: z.string(),
  revision: z.string(),
});

export function evalHistoricalImportObjectSourceToJSON(
  evalHistoricalImportObjectSource: EvalHistoricalImportObjectSource,
): string {
  return JSON.stringify(
    EvalHistoricalImportObjectSource$outboundSchema.parse(
      evalHistoricalImportObjectSource,
    ),
  );
}
export function evalHistoricalImportObjectSourceFromJSON(
  jsonString: string,
): SafeParseResult<EvalHistoricalImportObjectSource, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EvalHistoricalImportObjectSource$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EvalHistoricalImportObjectSource' from JSON`,
  );
}

/** @internal */
export const EvalHistoricalImportObject$inboundSchema: z.ZodType<
  EvalHistoricalImportObject,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("eval.import"),
  source: z.lazy(() => EvalHistoricalImportObjectSource$inboundSchema),
  suite_id: z.string(),
  suite_version: z.number().int(),
  created_suite: z.boolean(),
  created_suite_version: z.boolean(),
  dry_run: z.boolean(),
  discovered_files: z.number().int(),
  imported_runs: z.number().int(),
  skipped_runs: z.number().int(),
  imported_samples: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "suite_id": "suiteId",
    "suite_version": "suiteVersion",
    "created_suite": "createdSuite",
    "created_suite_version": "createdSuiteVersion",
    "dry_run": "dryRun",
    "discovered_files": "discoveredFiles",
    "imported_runs": "importedRuns",
    "skipped_runs": "skippedRuns",
    "imported_samples": "importedSamples",
  });
});
/** @internal */
export type EvalHistoricalImportObject$Outbound = {
  object: "eval.import";
  source: EvalHistoricalImportObjectSource$Outbound;
  suite_id: string;
  suite_version: number;
  created_suite: boolean;
  created_suite_version: boolean;
  dry_run: boolean;
  discovered_files: number;
  imported_runs: number;
  skipped_runs: number;
  imported_samples: number;
};

/** @internal */
export const EvalHistoricalImportObject$outboundSchema: z.ZodType<
  EvalHistoricalImportObject$Outbound,
  z.ZodTypeDef,
  EvalHistoricalImportObject
> = z.object({
  object: z.literal("eval.import"),
  source: z.lazy(() => EvalHistoricalImportObjectSource$outboundSchema),
  suiteId: z.string(),
  suiteVersion: z.number().int(),
  createdSuite: z.boolean(),
  createdSuiteVersion: z.boolean(),
  dryRun: z.boolean(),
  discoveredFiles: z.number().int(),
  importedRuns: z.number().int(),
  skippedRuns: z.number().int(),
  importedSamples: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    suiteId: "suite_id",
    suiteVersion: "suite_version",
    createdSuite: "created_suite",
    createdSuiteVersion: "created_suite_version",
    dryRun: "dry_run",
    discoveredFiles: "discovered_files",
    importedRuns: "imported_runs",
    skippedRuns: "skipped_runs",
    importedSamples: "imported_samples",
  });
});

export function evalHistoricalImportObjectToJSON(
  evalHistoricalImportObject: EvalHistoricalImportObject,
): string {
  return JSON.stringify(
    EvalHistoricalImportObject$outboundSchema.parse(evalHistoricalImportObject),
  );
}
export function evalHistoricalImportObjectFromJSON(
  jsonString: string,
): SafeParseResult<EvalHistoricalImportObject, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EvalHistoricalImportObject$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EvalHistoricalImportObject' from JSON`,
  );
}
